import styled from "react-emotion";
export interface TileContentInterface {
  theme?: any;
}
export const TileContent = styled("div")((props: TileContentInterface) => ({
  position: "absolute",
  bottom: props.theme.spacing.unit * 3
}));
